import { createRouter, createWebHistory } from "vue-router"
import Register from "@/views/Register/Register.vue"
import SelectDeliveryTime from "@/views/Register/SelectDeliveryTime.vue"
import DeliveryPicker from "@/views/Register/DeliveryPicker.vue"
import FillingData from "@/views/Register/FillingData.vue"
import CheckEmail from "@/views/Register/CheckEmail.vue"
import Account from "@/views/Account.vue"
// import Deals from "@/views/Deals.vue" // Replaced by OrdersListPage
import Favorites from "@/views/Favorites.vue"
import Market from "@/views/Market.vue"
import PersonalInfo from "@/views/Account/PersonalInfo.vue"
import MyProducts from "@/views/Account/MyProducts.vue"
import AddedProduct from "@/views/Account/AddedProduct.vue"
import EditProduct from "@/views/Account/EditProduct.vue"
import UploadExcel from "@/views/Account/UploadExcel.vue"
import Notifications from "@/views/Account/Notifications.vue"
import SelectModel from "@/views/Account/SelectModel.vue"
import EditDeliveryTime from "@/views/Account/EditDeliveryTime.vue"
import BecomeSeller from "@/views/Account/BecomeSeller.vue"
import Docs from "@/views/Account/Docs.vue"
import DocsRules from "@/views/Account/DocsRules.vue"
import DocsPrivacy from "@/views/Account/DocsPrivacy.vue"
import DocsPersonalData from "@/views/Account/DocsPersonalData.vue"
import Faq from "@/views/Account/Faq.vue"
import Filters from "@/components/FiltersModal.vue"
import Model from "@/views/Market/Model.vue"
import Product from "@/views/Market/Product.vue"
import Seller from "@/views/Market/Seller.vue"
import Brand from "@/views/Market/Brand.vue"
import Bid from "@/views/Bid.vue"
import SelectSize from "@/views/SelectSize.vue"
// import DealDetails from "@/views/DealDetails.vue" // Replaced by OrderDetailsPage

const routes = [
  // Account
  {
    path: "/",
    name: "account",
    component: Account,
    meta: { tgBack: "disabled" },
  },
  {
    path: "/personal-info",
    name: "PersonalInfo",
    component: PersonalInfo,
    meta: {
      tgBack: "custom",
      tgBackHandler: ({ router }) => router.push("/"),
    },
  },
  {
    path: "/edit-delivery-time",
    name: "EditDeliveryTime",
    component: EditDeliveryTime,
    meta: { tgBack: "history" },
  },
  {
    path: "/become-seller",
    name: "BecomeSeller",
    component: BecomeSeller,
    meta: { tgBack: "history" },
  },
  {
    path: "/my-products",
    name: "MyProducts",
    component: MyProducts,
    meta: { tgBack: "history" },
  },
  {
    path: "/add-product",
    name: "AddedProduct",
    component: AddedProduct,
    meta: { tgBack: "history" },
  },
  {
    path: "/edit-product/:id",
    name: "EditProduct",
    component: EditProduct,
    meta: { tgBack: "history" },
  },
  {
    path: "/upload-excel",
    name: "UploadExcel",
    component: UploadExcel,
    meta: { tgBack: "history" },
  },
  {
    path: "/select-model",
    name: "SelectModel",
    component: SelectModel,
    meta: { tgBack: "history" },
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: Notifications,
    meta: { tgBack: "history" },
  },
  {
    path: "/docs",
    name: "Docs",
    component: Docs,
    meta: { tgBack: "history" },
  },
  {
    path: "/docs/rules",
    name: "DocsRules",
    component: DocsRules,
    meta: { tgBack: "history" },
  },
  {
    path: "/docs/privacy-policy",
    name: "DocsPrivacy",
    component: DocsPrivacy,
    meta: { tgBack: "history" },
  },
  {
    path: "/docs/personal-data",
    name: "DocsPersonalData",
    component: DocsPersonalData,
    meta: { tgBack: "history" },
  },
  {
    path: "/docs/empty",
    name: "DocsEmpty",
    component: () => import("@/views/Account/DocsEmpty.vue"),
    meta: { tgBack: "history" },
  },
  {
    path: "/faq",
    name: "Faq",
    component: Faq,
    meta: { tgBack: "history" },
  },

  // Deals (Orders)
  {
    path: "/deals",
    name: "deals",
    component: () => import("@/features/orders/ui/pages/OrdersListPage.vue"),
    meta: { tgBack: "disabled" },
  },
  {
    path: "/deal/:id",
    name: "deal-details",
    component: () => import("@/features/orders/ui/pages/OrderDetailsPage.vue"),
    meta: { tgBack: "history" },
  },
  {
    path: "/deal/:id/feedback",
    name: "deal-feedback",
    component: () => import("@/features/orders/ui/pages/FeedbackPage.vue"),
    meta: { tgBack: "history" },
  },
  {
    path: "/deal/:id/extend",
    name: "extend-delivery",
    component: () =>
      import("@/features/orders/ui/pages/ExtendDeliveryPage.vue"),
    meta: { tgBack: "history" },
  },
  {
    path: "/deal/:id/decline",
    name: "decline-reason",
    component: () => import("@/features/orders/ui/pages/DeclineReasonPage.vue"),
    meta: { tgBack: "history" },
  },
  {
    path: "/deal/:id/cancel",
    name: "cancel-reason",
    component: () => import("@/features/orders/ui/pages/CancelReasonPage.vue"),
    meta: { tgBack: "history" },
  },
  {
    path: "/deal/:id/propose-price",
    name: "propose-price",
    component: () => import("@/features/orders/ui/pages/ProposePricePage.vue"),
    meta: { tgBack: "history" },
  },

  // Favorites
  {
    path: "/favorites",
    name: "favorites",
    component: Favorites,
    meta: { tgBack: "disabled" },
  },
  {
    path: "/filters",
    name: "filters",
    component: Filters,
    meta: { tgBack: "history" },
  },

  // Market
  {
    path: "/market",
    name: "market",
    component: Market,
    meta: { tgBack: "disabled" },
  },
  {
    path: "/model/:id",
    name: "Model",
    component: Model,
    meta: { tgBack: "history" },
  },
  {
    path: "/product/:id",
    name: "Product",
    component: Product,
    meta: { tgBack: "history" },
  },
  {
    path: "/seller/:id",
    name: "Seller",
    component: Seller,
    meta: { tgBack: "history" },
  },
  {
    path: "/brand/:brand",
    name: "Brand",
    component: Brand,
    meta: { tgBack: "history" },
  },
  {
    path: "/bid",
    name: "Bid",
    component: Bid,
    meta: { tgBack: "history" },
  },
  {
    path: "/model/:modelId/select-size",
    name: "SelectSize",
    component: SelectSize,
    meta: { tgBack: "history" },
  },

  // Register
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: { tgBack: "disabled" },
  },
  {
    path: "/select-delivery-time",
    name: "SelectDeliveryTime",
    component: SelectDeliveryTime,
    meta: { tgBack: "history" },
  },
  {
    path: "/delivery-picker",
    name: "DeliveryPicker",
    component: DeliveryPicker,
    meta: { tgBack: "history" },
  },
  {
    path: "/filling-data",
    name: "FillingData",
    component: FillingData,
    meta: { tgBack: "history" },
  },
  {
    path: "/check-email",
    name: "CheckEmail",
    component: CheckEmail,
    meta: { tgBack: "history" },
  },
]

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // Смена параметра того же маршрута (например, переключение размера
    // товара: Product/{id} → Product/{другой id}) — не скроллим страницу,
    // иначе она "прыгает" наверх.
    if (to.name === from.name && to.name !== null) {
      return false
    }
    return { left: 0, top: 0 }
  },
})
